import { useEffect } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { hasPrivilege } from "../api/token";
import ModemCard from "../components/ModemCard";

function ModemEdit() {
  const navigate = useNavigate();
  const params = useParams();
  const modem_edit = hasPrivilege('modem_edit');

  useEffect(() => {
    if (!modem_edit) {
      navigate("/");
    }
  }, [navigate, modem_edit])

  if (modem_edit) {
    return <ModemCard ident={params.uuid} editable={true} />;
  }
}

export default ModemEdit;
